import { FolderItem, Location } from "@/types/fse";
import * as React from "react";
import { ROOT_DRIVE_NAME } from "@/views/drive/consts";
import { Link } from "react-router";

interface Props {
  currentLocation: Location;
  currentFolder: FolderItem;
}

export const DriveHeaderBreadcrumbs: React.FC<Props> = ({ currentLocation, currentFolder }) => {
  const isRoot = currentFolder.name === ROOT_DRIVE_NAME;

  return (
    <nav className="flex flex-wrap text-sm text-gray-600">
      {isRoot ? (
        <span>My Folders</span>
      ) : (
        <>
          {currentLocation?.path.map(breadcrumb => (
            <React.Fragment key={breadcrumb.id}>
              <span className="mx-2">{">"}</span>
              <Link to={`/drive/${breadcrumb.id}`} className="hover:underline">
                {breadcrumb?.name}
              </Link>
            </React.Fragment>
          ))}
          <span className="mx-2">{">"}</span>
          <span>{currentFolder.name}</span>
        </>
      )}
    </nav>
  );
};
